import React from "react";

const CopyContext = React.createContext({
  copyColor: () => {}
});

export default CopyContext;
